import React from 'react';

const FeatureCard = ({ title, description, icon, className = '', titleClassName = '', descriptionClassName = '', children }) => {
  return (
    <div className={`rounded p-6 ${className}`}>
      {icon && <div className="mb-4">{icon}</div>}
      <h3 className={`text-xl font-semibold mb-2 text-white ${titleClassName}`}>{title}</h3>
      <p className={`text-neutral-400 text-sm ${descriptionClassName}`}>{description}</p>
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
};

export default FeatureCard;


